(function() {
  function adjustMasonryHeight() {
    const tiles = document.getElementById('resource-tiles');
    if (!tiles) return;
    const tileEls = tiles.querySelectorAll('.tile');
    if (!tileEls.length) return;
    const heights = [0, 0, 0];
    tileEls.forEach((tile, i) => {
      heights[i % 3] += tile.offsetHeight;
    });
    tiles.style.height = Math.max(...heights) + 'px';
  }

  let resizeScheduled = false;
  let settleTimeout;
  function scheduleAdjustMasonryHeight() {
    if (!resizeScheduled) {
      resizeScheduled = true;
      requestAnimationFrame(() => {
        resizeScheduled = false;
        adjustMasonryHeight();
      });
    }
    // Guarantees a final recalculation even if the last resize event's
    // rAF-scheduled update races with the browser's own layout timing.
    clearTimeout(settleTimeout);
    settleTimeout = setTimeout(adjustMasonryHeight, 200);
  }

  document.addEventListener('turbolinks:load', adjustMasonryHeight);
  window.addEventListener('resize', scheduleAdjustMasonryHeight);
})();
